import StethoscopeIcon from '@/assets/icons/physician-exam-counter-stethoscope.svg?raw'

const emptyCounter = () => ({
  queue: 0,
  available: 0,
  delayed: 0
})

export default {
  name: 'physician-exam-counters',
  props: {
    elective: {
      type: Object,
      default: emptyCounter
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      stethoscopeIcon: StethoscopeIcon
    }
  }
}
